<div class="page-layout carded left-sidenav toolbar-fixed-layout">
  <div *ngIf="viewType=='Compact'" class="compact-breadcumb-view flex flex-row justify-start items-center">
    <particle-select-basket (basketChange)="onBasketChange($event)" class="m-l-30 m-r-20"></particle-select-basket>
    <particle-breadcumb-tab-action [breadcrumbs]="breadcrumbs"
                                   [tabs]="tabs"
                                   [selectedTab]="selectedTab"
                                   [actions]="actions"
                                   (viewTypeChanged)="viewTypeChanged($event)"
                                   (selectedTabChanged)="onSelectedTabChanged($event)"
    >
    </particle-breadcumb-tab-action>
  </div>
  <div *ngIf="viewType!='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-start items-center">
      <particle-select-basket class="m-r-20" (basketChange)="onBasketChange($event)"></particle-select-basket>
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
      <button class="view-change" (click)="compactViewType()">
        <i class="fas fa-expand-alt"></i>
      </button>
    </div>
  </div>
  <div *ngIf="viewType!=='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="createCase()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Create Case
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <particle-grid-apply-filter *ngIf="filterId" [filterId]="filterId"-->
        <!--                                      [endpointName]="endpoint"-->
        <!--                                      [invalidateSubject]="invalidateSubject">-->
        <!--          </particle-grid-apply-filter>-->

        <!--          <div class="toolbar-separator m-l-10"></div>-->
        <!--        </div>-->
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="import()"
                  particleAnalytics
                  analyticsCategory="import"
                  analyticsAction="import"
          >Import
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="exportPreArrangement()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Export
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="manageSection()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="manage-fields"
          >Manage Fields
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="archive()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="archive"
          >Archive Case(s)
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <mat-slide-toggle class="left-margin" [(ngModel)]="showArchived" (change)="showArchivedChanged()">Show
            Archived
          </mat-slide-toggle>
          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <button mat-button class="start-data-survey" (click)="startDataSurvey()"><i class="fal fa-play"></i> Create
          Survey Template
        </button>
      </div>
    </div>
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div particleHelpNotes helpNoteId="dac6-pre-arrangement" class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->


        <div class="content  pos-relative flex flex-col full-grow-no-shrink-no-basis">
          <div class="keno-grid-container">
            <particle-virtual-grid [sourceKey]="sourceType"
                                   sortFieldKey="CaseId"
                                   sortDirection="desc"
                                   prefixSortFieldKey="FieldValues."
                                   [sortEnabled]="true"
                                   [invalidateSubject]="invalidateSubject"
                                   (valueChanged)="onGridCellValueChange($event)"
                                   [viewType]="viewType"
                                   (fieldSectionChanged)="onFieldSectionChanged($event)"
                                   [rowClass]="rowCallback"
                                   serviceName="PreArrangementDynamicItemService"
                                   api="DAC6Api"
                                   [showAnnouncement]="showAnnouncement"
                                   [announcementContent]="announcementContent"
                                   (onAnnouncementDismissed)="onAnnouncementDismissed()"
            >
            </particle-virtual-grid>
          </div>
        </div>


      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
